import { Box, Button, Link, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { Trans } from 'react-i18next';

import { CaymanLogo, LogoContainerResponsive } from '@/components/Icon/Logo';
import { Form } from '@/components/Layout/Layout.styled';
import { Page } from '@/components/Layout/Page/Page';
import {
  ContentContainer,
  ResponsiveMarginTopMessage,
} from '@/components/Layout/Page/Page.styled';

import { useAppDispatch } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { signOut } from '@/redux/auth/actions';

import { getDataTestId } from '@/utils/browser';

export function CaymanCountryValidationFailedPage() {
  const { t } = useTranslate();
  const dispatch = useAppDispatch();
  const onBackToSignIn = () => dispatch(signOut());

  return (
    <Page
      paperProps={{
        position: 'right',
        size: 'big',
        hasLogo: false,
        color: (theme: Theme) => theme.palette.overlay.forest.start,
        secondColor: (theme: Theme) => theme.palette.overlay.forest.end,
        children: <CaymanLogo alt="cayman-non-residents-logo" />,
      }}
    >
      <ContentContainer>
        <LogoContainerResponsive>
          <CaymanLogo alt="cayman-non-residents-logo" />
        </LogoContainerResponsive>
        <ResponsiveMarginTopMessage
          variant="headlineH3"
          {...getDataTestId('cayman-validation-failed-page-title')}
        >
          {t('createNewAccount.caymanResidentValidationFailed.header')}
        </ResponsiveMarginTopMessage>
        <Typography
          variant="bodyB2Regular"
          mt={4}
          {...getDataTestId('cayman-validation-failed-page-body')}
        >
          <Trans
            i18nKey="createNewAccount.caymanResidentValidationFailed.body"
            components={{
              PhoneLink: (
                <Link
                  color="primary"
                  fontWeight="bold"
                  href="tel:345-949-8300"
                />
              ),
            }}
          />
        </Typography>
      </ContentContainer>
      <Box width="100%">
        <Form>
          <Button
            onClick={onBackToSignIn}
            {...getDataTestId('cayman-validation-failed-page-login-button')}
          >
            {t(
              'createNewAccount.caymanResidentValidationFailed.button.backToLogin',
            )}
          </Button>
        </Form>
      </Box>
    </Page>
  );
}

export default CaymanCountryValidationFailedPage;
